import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { normalize } from 'utils/stringFunctions';
import { useQuality, } from 'actions/storylet';

import PossessionsContext from 'components/Possessions/PossessionsContext';
import InventoryItemComponent from './InventoryItemComponent';
import { IAppState } from 'types/app';
import { IQuality } from 'types/qualities';
import { ITooltipData } from 'components/ModalTooltip/types';

interface OwnProps {
  data: IQuality,
  dispatch: Function,
  overrideLevels?: boolean,
  profile?: boolean,
}

interface StateProps {
  currentlyInStorylet: boolean,
  itemsUsableHere: boolean,
  isRequestingItemUse: boolean,
}

class InventoryItemContainer extends Component<OwnProps & StateProps & RouteComponentProps, {}> {
  static displayName = 'InventoryItemContainer';

  handleClick = (_?: any) => {
    const {
      dispatch,
      history,
      data: { id },
    } = this.props;

    if (this.isCurrentlyUsable()) {
      dispatch(useQuality(id, history));
    }
  };

  isCurrentlyUsable = () => {
    const {
      data,
      itemsUsableHere,
      profile,
      currentlyInStorylet,
    } = this.props;
    const { useEventId } = data;
    return !!useEventId && itemsUsableHere && !profile && !currentlyInStorylet;
  };

  render() {
    const {
      currentlyInStorylet,
      data,
      isRequestingItemUse,
      itemsUsableHere,
      overrideLevels,
      profile,
    } = this.props;

    const {
      availableAt,
      description,
      id,
      image,
      level,
      name,
      useEventId,
    } = data;

    const hasUseEventId = !!useEventId;

    let tooltipData: ITooltipData = {
      ...data,
      description: `<p>${description}</p>${(data.availableAt ? `<p class="tooltip__available-at">${availableAt}</p>` : '')}`,
      level: overrideLevels ? undefined : level,
      // TODO: this is indeed ugly
      // eslint-disable-next-line no-nested-ternary, quotes
      secondaryDescription: hasUseEventId ? currentlyInStorylet ? "<span class='item-use-warning'>You're in a storylet at the moment - you must finish it before you can use this item.</span>" : "Click on this item in your inventory to use it." : undefined,
      smallButtons: [],
    };

    if (hasUseEventId && !currentlyInStorylet) {
      tooltipData = {
        ...tooltipData,
        smallButtons: [{
          label: 'Use',
          action: this.handleClick,
        }],
      };
    }

    const isUsableButBlocked = (
      hasUseEventId && !profile && (currentlyInStorylet || !itemsUsableHere)
    );

    return (
      <PossessionsContext.Consumer>
        {({ filterString }) => {
          if (normalize(name).indexOf(normalize(filterString)) < 0) {
            return null;
          }
          return (
            <InventoryItemComponent
              defaultCursor={isRequestingItemUse || !useEventId || !this.isCurrentlyUsable()}
              id={id}
              image={image}
              isBlocked={isUsableButBlocked}
              isLoading={isRequestingItemUse}
              isUsable={this.isCurrentlyUsable()}
              name={name}
              onClick={this.handleClick}
              tooltipData={tooltipData}
            >
              {overrideLevels ? null : <span className="js-item-value icon__value">{level}</span>}
            </InventoryItemComponent>
          );
        }}
      </PossessionsContext.Consumer>
    );
  }
}

const mapStateToProps = ({
  map: { itemsUsableHere },
  myself: { isRequestingItemUse },
}: IAppState) => ({ isRequestingItemUse, itemsUsableHere });

export default withRouter(
  connect(mapStateToProps)(InventoryItemContainer),
);